import { render, staticRenderFns } from "./handmadePrescription.vue?vue&type=template&id=79b54b87&scoped=true"
import script from "./handmadePrescription.vue?vue&type=script&lang=js"
export * from "./handmadePrescription.vue?vue&type=script&lang=js"
import style0 from "./handmadePrescription.vue?vue&type=style&index=0&id=79b54b87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b54b87",
  null
  
)

export default component.exports